export const formatTimestamp = (timestamp: number): string => {
  const date = new Date(timestamp);

  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};
